import React from 'react';
import ModalWrapper from './ModalWrapper';
import { GreenFilledTickIcon, RedLockWithKeyHoleIcon } from 'assets/icons';

const features = [
  'Create and collaborate on unlimited Jobs',
  'Link estimates and invoices for full job history',
  'Track pay automatically with Commission Rules',
  'Add job expenses to see true profitability'
];

type FSMNotAvaialbleModalProps = {
  className?: string;
};

const FSMNotAvaialbleModal: React.FC<FSMNotAvaialbleModalProps> = () => {
  const handleChatWithUsClick = () => {
    if (window.fcWidget) window.fcWidget.open();
  };

  return (
    <ModalWrapper>
      <div
        className="customTransparentScroll max-h-[90vh] w-[90%] max-w-4xl 
        overflow-auto rounded-xl bg-white p-6 shadow-xl md:w-[579px]">
        <RedLockWithKeyHoleIcon className="mx-auto h-16 w-16" />
        <h2 className="mb-2 text-center text-2xl font-bold text-heading">Looks like Field Serve is off</h2>
        <p className="mb-6 text-center text-17px font-semibold text-primaryText">
          To use this feature, your business owner needs to turn on the Field Services add-on for your team.
        </p>
        <div className="mb-4 w-full rounded-md border border-borderGray bg-white p-5">
          <div className="font-sbase mb-3.5 font-semibold text-primaryText">What you'll get once it's on</div>
          <ul className="list-none space-y-4">
            {features.map((feature, idx) => (
              <li key={idx} className="flex items-center gap-2 text-sbase text-primaryText">
                <GreenFilledTickIcon className="h-2.5 w-2.5" />
                {feature}
              </li>
            ))}
          </ul>
        </div>
        <div className="text-center text-sbase font-medium text-accentText">
          Need help?{' '}
          <button
            type="button"
            onClick={handleChatWithUsClick}
            className="cursor-pointer font-bold text-secondary"
            tabIndex={0}
            aria-label="Chat with us">
            Chat with us
          </button>
        </div>
      </div>
    </ModalWrapper>
  );
};

export default FSMNotAvaialbleModal;
